import { SignInView } from "~auth/views/sign-in";
import { RedirectToPortal } from "~auth/hoc/redirect-to-portal";
import { NextPage } from "next";
import { NextSeo } from "next-seo";

const SignInPage: NextPage = () => {
	return (
		<>
			<NextSeo
				title="Sign in"
				description="Sign in to manage your maps and data."
				canonical="https://mangomap.com/sign-in"
				openGraph={{
					title: "Sign in",
					description: "Sign in to manage your maps and data.",
					url: "https://mangomap.com/sign-in",
					site_name: "Mango GIS",
				}}
			/>
			<RedirectToPortal>
				<SignInView />
			</RedirectToPortal>
		</>
	);
};

export default SignInPage;
